__turbopack_context__.v({
  "className": "inter_355c38ce-module__5lmpcq__className",
});
